// Role names as people in the university say them
export const ROLE_LABELS = {
  admin: "Administrator",
  user: "Utilizator",
  usersef: "Șef de departament",
  inginer: "Inginer",
  "inginer-pc": "Inginer PC",
  dtisef: "Șef DTI",
  rector: "Rector",
  contability: "Contabilitate",
  operator: "Operator",
  profesor: "Profesor",
};

export function roleLabel(role) {
  return ROLE_LABELS[role] || role || "";
}

// Roles that head a department (same list as SEF_ROLES on the server)
export const SEF_ROLES = ["usersef", "dtisef"];

// Roles that have the Aprobare page (links.json / router guard)
export const APPROVER_ROLES = ["admin", "inginer", "usersef", "dtisef", "rector", "contability", "inginer-pc"];
